import { motion } from "framer-motion";

function Mission() {
  return (
    <>
      {/* Page load animation */}
      <motion.div
        initial={{ width: "100vw", height: "100vh", borderRadius: 0, transformOrigin: "center" }}
        animate={{ width: 0, height: 0, borderRadius: "100%", transformOrigin: "center" }}
        transition={{ duration: 0.5, ease: "easeInOut" }}
        className="absolute top-1/2 left-1/2 bg-custom-ivory z-40 -translate-x-1/2 -translate-y-1/2"
      />

      <div className="flex justify-center px-3 sm:px-6 md:px-12 py-10 bg-custom-ivory">
        <div className="w-full max-w-4xl">
          <h1 className="text-2xl sm:text-3xl md:text-4xl font-semibold text-custom-maroon text-center mb-6">
            Mission
          </h1>

          <p className="text-base sm:text-lg md:text-xl text-custom-yellow mb-6 text-justify break-words">
            "Anand to Sadanand - Uplifting your soul towards complete uninterrupted bliss" represents a profound spiritual journey from joy (Anand) to eternal happiness (Sadanand). This mission is about guiding individuals towards a higher state of consciousness, where one transcends the fleeting pleasures of the material world and experiences a lasting, profound sense of bliss that is uninterrupted and ever-present. The path from Anand to Sadanand involves cultivating inner peace, mindfulness, and spiritual practices that elevate the soul. It is a holistic approach, emphasizing meditation, self-realization, and detachment from worldly distractions.
          </p>

          <p className="text-base sm:text-lg md:text-xl text-custom-yellow mb-6 text-justify break-words">
            Through this journey, one learns to align the body, mind, and spirit, allowing them to move beyond the limitations of ego and desires. The aim is to reach a state where bliss is not momentary but becomes a constant, integrated part of one's being. It is the realization that true happiness comes from within and that by connecting with the divine essence, one can experience an infinite state of Sadanand – a blissful state that is untouched by external circumstances. This mission seeks to uplift individuals, transforming their lives into a continuous flow of joy, peace, and spiritual fulfillment.
          </p>
        </div>
      </div>
    </>
  );
}

export default Mission;
